import { observer } from 'mobx-react'
import { NextPage } from 'next'
import { VerticalNavMessagePageTemplate } from '@/components/templates/VerticalNavMessagePageTemplate'
import { MyHead } from '@/components/molecules/MyHead'
import { DEFAULT_NFTS_PAGE_HEADER_IMAGE_PATH } from '@/constants'
import { StakeTokenGroup } from '@/components/organisms/StakeTokenGroup'
import styles from './index.module.scss'

const Stake: NextPage = observer(() => {
  return (
    <VerticalNavMessagePageTemplate>
      <MyHead title='Stake AQA' />
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.headerContainer}>
            <img src={DEFAULT_NFTS_PAGE_HEADER_IMAGE_PATH} alt='Header' className={styles.headerImage} />
            <div className={styles.headerContent}>
              <figure className={styles.headerLogo}>
                <img src='/images/common/nft_logo.png' alt='nft_logo' className='img-fluid' />
              </figure>
              <div>
                <p className={styles.headerTitle}>Stake AQA</p>
                <p className={styles.headerDescription}>
                  {/* AQA NFT represents an exciting new development in the Web3 ecosystem. */}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.content}>
          <StakeTokenGroup />
        </div>
      </div>
    </VerticalNavMessagePageTemplate>
  )
})

export default Stake
